import { render, staticRenderFns } from "./CompanyUserUpsertModal.vue?vue&type=template&id=5a2b920a"
import script from "./CompanyUserUpsertModal.vue?vue&type=script&lang=js"
export * from "./CompanyUserUpsertModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyUserUpsertModal.vue?vue&type=style&index=0&id=5a2b920a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports